// ─────────────────────────────────────────────────────────────────────────────
// theme/mxp-homepage.js — Afișarea bannerelor pe homepage
//
// Rulează în flux, chiar la locul secțiunii, înainte să se așeze restul paginii. Preia răspunsul
// cererii pornite din <head> de mxp-preload.liquid și, numai dacă vin exact 2 bannere, umple cu ele
// scheletul din mxp-homepage.liquid: texte, poze, linkuri. Secțiunea stă ascunsă până atunci, cu o
// singură excepție: dacă browserul ține minte că vizitatorul a primit bannere în ultimele 7 zile,
// locul lor se rezervă din prima clipă, ca pagina să nu mai coboare când sosesc. Decizia se cere la
// fiecare intrare pe homepage; din vizita precedentă rămâne doar semnul că au existat bannere.
//
// Pe paginile alese în mxp-preload.liquid, un banner general al temei (elementul cu `data-mxp-product-type`)
// cu un singur tip de produs, același cu al unui banner personalizat, îi ia locul în secțiunea
// noastră: cel cu tipul bannerului 1 pe poziția 1, cel cu tipul bannerului 2 pe poziția 2, cu poza
// bannerului personalizat (produsul clientului). Bannerul personalizat înlocuit nu se mai afișează, iar
// locul rămas în grila temei primește un banner de rezervă de la server, cu un tip care nu e încă pe
// pagină, construit ca bannerele temei. Înlocuirile se măsoară aici; afișările și clicurile bannerelor
// temei, în mxp-tracker.js.
//
// Înaintea regulii de mai sus vine bannerul camerei: un banner al temei cu perechea de tipuri a camerei
// (`Pat, Comodă`, `Canapea, Fotoliu`, `Masă, Scaun`). Când camera clientului are unul, rândul lui urcă în
// locul secțiunii noastre, cu el primul și perechea lui alături (dormitor și dining → Canapele și fotolii,
// living → Mobilier dormitor), iar el primește subtitlul, eticheta și linkul bannerului nostru 1. Bannerul
// scos din rând îi ia locul în rândul de unde a plecat. Secțiunea noastră rămâne ascunsă.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  'use strict';

  var CFG = window.MXP_BANNERS || {};
  // Învelișul pe care îl pune Shopify în jurul secțiunii, din `class` din schema.
  var SECTIUNE_SELECTOR = '.mxp-homepage-section .mxp-banners';

  // Lățimile cerute CDN-ului pentru poze și regula după care browserul alege una.
  var IMG_WIDTHS = [400, 600, 800, 1200];
  var IMG_SIZES = '(max-width: 600px) 100vw, 50vw';

  // Raportul casetei, același ca BANNER_RATIO_W/H din src/decisions/bannerImage.ts și ca
  // `aspect-ratio` din mxp-homepage.liquid.
  var IMG_RATIO_W = 770;
  var IMG_RATIO_H = 479;
  var PENDING_CLASS = 'mxp-banners--img-pending';
  var AWAIT_CLASS = 'mxp-banners--data-pending';
  var PENDING_TIMEOUT_MS = 1000;

  // Semnul din browser: momentul ultimului răspuns cu bannere. Cât timp e proaspăt, locul se
  // rezervă din prima clipă, ca bannerele să nu mai împingă pagina în jos când sosesc.
  var MEMO_KEY = 'mxp_bannere';
  var MEMO_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var CONSENT_COOKIE = 'mxp_consent';

  // Adresa deciziei, dedusă din adresa aplicației pusă de mxp-preload.liquid în <head>.
  var API_BANNERS =
    window.MXP_CONFIG && window.MXP_CONFIG.endpoint
      ? String(window.MXP_CONFIG.endpoint).replace(/\/v1\/events\/?$/, '/v1/homepage/banners')
      : '';

  // Identitatea anonimă, pusă de senzor în cookie.
  var ANON_COOKIE = 'mxp_aid';
  var ANON_PATTERN = /^a_[a-z0-9]{12,}$/;

  // --- ajutoare -------------------------------------------------------------

  // Acceptă doar http(s) sau cale relativă; blochează `javascript:` și restul.
  function safeUrl(u) {
    if (typeof u !== 'string' || u === '') return '';
    if (u.charAt(0) === '/') return u;
    return /^https?:\/\//i.test(u) ? u : '';
  }

  function isText(v) {
    return typeof v === 'string' && v !== '';
  }

  // Valoarea unui cookie, sau '' dacă lipsește.
  function cookie(name) {
    var parts = String(document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].replace(/^\s+/, '');
      if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.slice(name.length + 1));
    }
    return '';
  }

  // Pune textul în element; fără text, ascunde elementul.
  function fillText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el === null) return;
    if (isText(value)) {
      el.textContent = value;
      el.style.removeProperty('display');
    } else {
      el.style.display = 'none';
    }
  }

  // Eticheta pentru cititoarele de ecran: titlu, subtitlu, buton.
  function ariaLabel(ov) {
    var parts = [];
    if (isText(ov.headline)) parts.push(ov.headline);
    if (isText(ov.subhead)) parts.push(ov.subhead);
    if (isText(ov.disclaimer)) parts.push(ov.disclaimer);
    if (isText(ov.cta_text)) parts.push(ov.cta_text);
    return parts.join('. ');
  }

  // Pozele de pe CDN-ul Shopify acceptă `?width=` și vin gata redimensionate.
  function isShopifyCdn(u) {
    return /(^https?:\/\/cdn\.shopify\.com\/)|(\/cdn\/shop\/)/i.test(u);
  }

  // Aceeași poză, cerută la lățimea `w`: se scoate tot decupajul din adresă și se cere din nou,
  // pe caseta lățimii noi, fiindcă o înălțime rămasă de la altă lățime ar tăia poza strâmb.
  function resized(u, w) {
    if (!isShopifyCdn(u)) return u;
    var base = u
      .split('#')[0]
      .replace(/([?&])(width|height|crop)=[^&]*/gi, '$1')
      .replace(/&{2,}/g, '&')
      .replace(/[?&]+$/, '');
    var h = Math.round((w * IMG_RATIO_H) / IMG_RATIO_W);
    return (
      base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w + '&height=' + h + '&crop=center'
    );
  }

  // Mai multe lățimi, din care browserul alege una potrivită ecranului.
  function srcsetFor(u) {
    if (!isShopifyCdn(u)) return '';
    return IMG_WIDTHS.map(function (w) {
      return resized(u, w) + ' ' + w + 'w';
    }).join(', ');
  }

  // --- umplerea unui banner -------------------------------------------------

  // Poza bannerului personalizat: varianta redimensionată + srcset. width/height rămân pe <img>, deci nu
  // se mișcă nimic.
  function punePoza(img, ov) {
    var src = safeUrl(ov.image_url);
    if (img === null || src === '') return;
    var set = srcsetFor(src);
    if (set !== '') {
      img.setAttribute('sizes', IMG_SIZES);
      img.setAttribute('srcset', set);
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.setAttribute('src', resized(src, 800));
    if (isText(ov.headline)) img.setAttribute('alt', ov.headline);
  }

  // Textele bannerului, cu ale modelului ales în secțiune (`data-model`) peste ele, când serverul le trimite.
  function textele(anchor, slot) {
    var ov = (slot && slot.overrides) || {};
    var sectiune = anchor.closest('.mxp-banners');
    var model = sectiune ? sectiune.getAttribute('data-model') : '';
    var deModel = model && slot && slot.modele ? slot.modele[model] : null;
    if (!deModel) return ov;
    var toate = {};
    var k;
    for (k in ov) toate[k] = ov[k];
    for (k in deModel) toate[k] = deModel[k];
    return toate;
  }

  function applyBanner(anchor, slot) {
    var ov = textele(anchor, slot);

    fillText(anchor, '.mxp-banner__title', ov.headline);
    fillText(anchor, '.mxp-banner__subtitle', ov.subhead);
    fillText(anchor, '.mxp-banner__nota', ov.disclaimer);
    fillText(anchor, '.mxp-banner__button', ov.cta_text);
    punePoza(anchor.querySelector('.mxp-banner__image'), ov);

    var href = safeUrl(ov.collection_link);
    if (href !== '') anchor.setAttribute('href', href);

    var label = ariaLabel(ov);
    if (label !== '') anchor.setAttribute('aria-label', label);

    if (isText(slot.banner_id)) anchor.setAttribute('data-banner-id', slot.banner_id);
    anchor.setAttribute('data-mxp-hydrated', '1');
  }

  // Cele 2 poze apar odată: rămân transparente până se încarcă amândouă (sau expiră timpul), apoi
  // intră împreună cu un fade.
  function revealImagesTogether(root, images) {
    var remaining = images.length;
    var done = false;

    function reveal() {
      if (done) return;
      done = true;
      root.classList.remove(PENDING_CLASS);
    }

    function onSettled() {
      remaining -= 1;
      if (remaining <= 0) reveal();
    }

    root.classList.add(PENDING_CLASS);

    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.complete) {
        onSettled();
      } else {
        img.addEventListener('load', onSettled, { once: true });
        img.addEventListener('error', onSettled, { once: true });
      }
    }

    setTimeout(reveal, PENDING_TIMEOUT_MS);
  }

  // --- măsurarea: afișare și clic --------------------------------------------

  // Trimite un eveniment prin senzor sau, dacă senzorul (încărcat cu `defer`) n-a pornit încă, îl
  // lasă în `window.MXP_PENDING`, pe care senzorul o golește la pornire.
  function trimite(tip, date, imediat) {
    var api = window.MXP;
    if (api && typeof api.track === 'function') {
      api.track(tip, date);
      if (imediat && typeof api.flush === 'function') api.flush();
      return;
    }
    if (!window.MXP_PENDING) window.MXP_PENDING = [];
    window.MXP_PENDING.push({ type: tip, data: date });
  }

  // `banner_view`: fiecare banner al nostru rămas pe pagină și fiecare rezervă pusă se numără o dată, când
  // cel puțin jumătate din el ajunge pe ecran, ca la bannerele site-ului; cele ajunse deodată pleacă
  // într-un singur eveniment.
  function raporteazaAfisarea(anchors, inlocuite) {
    var elemente = [];
    for (var i = 0; i < anchors.length; i++) {
      if (inlocuite.indexOf(i) === -1 && isText(anchors[i].getAttribute('data-banner-id'))) elemente.push(anchors[i]);
    }
    var rezerve = document.querySelectorAll('[data-mxp-rezerva="1"][data-banner-id]');
    for (var r = 0; r < rezerve.length; r++) elemente.push(rezerve[r]);
    if (elemente.length === 0) return;
    var idul = function (el) {
      return el.getAttribute('data-banner-id');
    };
    if (typeof IntersectionObserver !== 'function') {
      trimite('banner_view', { banner_ids: elemente.slice(0, 4).map(idul) }, false);
      return;
    }
    var numarate = [];
    var obs = new IntersectionObserver(
      function (intrari) {
        var ids = [];
        for (var k = 0; k < intrari.length; k++) {
          var el = intrari[k].target;
          if (!intrari[k].isIntersecting || numarate.indexOf(el) !== -1) continue;
          obs.unobserve(el);
          numarate.push(el);
          ids.push(idul(el));
        }
        if (ids.length > 0) trimite('banner_view', { banner_ids: ids.slice(0, 4) }, false);
      },
      { threshold: 0.5 },
    );
    for (var j = 0; j < elemente.length; j++) obs.observe(elemente[j]);
  }

  // Poziția bannerului în secțiune (1 sau 2), după locul lui din schelet; 0 dacă nu e al nostru.
  function pozitia(anchors, anchor) {
    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i] === anchor) return i + 1;
    }
    return 0;
  }

  // `banner_click`: pleacă imediat, ca să prindă înainte de navigare.
  function ascultaClicurile(root, anchors) {
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      var anchor = t && typeof t.closest === 'function' ? t.closest('.mxp-banner') : null;
      if (anchor === null) return;
      var id = anchor.getAttribute('data-banner-id');
      if (!id) return;
      var poz = pozitia(anchors, anchor);
      if (poz !== 1 && poz !== 2) return;
      var date = { banner_id: id, position: poz };
      var href = anchor.getAttribute('href');
      // Aceeași regulă ca pe server: adresă http(s) completă sau cale de pe magazin.
      if (typeof href === 'string' && href.length <= 2048 && /^(https?:\/\/|\/)/.test(href)) {
        date.link = href;
      }
      trimite('banner_click', date, true);
    });
  }

  // --- bannerele generale ale temei -----------------------------------------

  var GENERAL_SELECTOR = '[data-mxp-product-type]';
  var POZA_GENERAL = '.image-wrapper img';

  // Un tip de produs pregătit pentru comparație: fără spații la capete, aceeași formă a diacriticelor.
  function normal(tip) {
    var t = String(tip).trim().toLowerCase();
    return typeof t.normalize === 'function' ? t.normalize('NFC') : t;
  }

  // Tipul de produs din linkul unui banner personalizat (`tip_produs=…`); nimic dacă lipsește.
  function tipulDinLink(slot) {
    var link = slot && slot.overrides && slot.overrides.collection_link;
    var m = typeof link === 'string' ? /[?&]tip_produs=([^&#]*)/.exec(link) : null;
    if (!m) return null;
    try {
      return normal(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    } catch (e) {
      return null;
    }
  }

  // Tipul unic al unui banner general, așa cum e scris; nimic dacă are mai multe tipuri sau niciunul.
  function tipulScris(el) {
    var tipuri = String(el.getAttribute('data-mxp-product-type') || '').split(',');
    var bune = [];
    for (var i = 0; i < tipuri.length; i++) {
      if (tipuri[i].trim() !== '') bune.push(tipuri[i].trim());
    }
    return bune.length === 1 ? bune[0] : null;
  }

  // O grilă care a ajuns deja în ecran (se vede acum sau omul a trecut de ea) nu se atinge: omul ar vedea
  // bannerul dispărând.
  function eDejaPeEcran(grila) {
    return grila.getBoundingClientRect().top < (window.innerHeight || document.documentElement.clientHeight);
  }

  // Bannerele generale ale grilei (cele cu `data-mxp-product-type`), în ordine; stilurile dintre ele nu se
  // socotesc la poziții.
  function copiiiGrilei(grila) {
    var out = [];
    for (var i = 0; i < grila.children.length; i++) {
      if (grila.children[i].hasAttribute('data-mxp-product-type')) out.push(grila.children[i]);
    }
    return out;
  }

  // Primul banner general de pe pagină cu tipul cerut, dintr-o grilă care nu e încă în ecran.
  function generalulCuTipul(tip) {
    var toate = document.querySelectorAll(GENERAL_SELECTOR);
    for (var i = 0; i < toate.length; i++) {
      var t = tipulScris(toate[i]);
      if (t !== null && normal(t) === tip && !eDejaPeEcran(toate[i].parentNode)) return toate[i];
    }
    return null;
  }

  // Bannerul mutat sus e primul de pe pagină, deci poza lui se încarcă pe loc, ca la primele bannere ale
  // temei: fără clasele încărcării întârziate, care ar face-o să clipească.
  function pozaFaraIncarcareTarzie(img) {
    if (img !== null) img.classList.remove('lazyload', 'lazyloading', 'lazyloaded', 'ls-is-cached');
  }

  // Etichetele temei de pe poză (`.AI-class`, oricare le-ar fi textul) sunt despre poza temei; pe poza
  // produsului clientului nu mai sunt adevărate, așa că se scot.
  function faraEtichetaAI(banner) {
    var etichete = banner.querySelectorAll('.AI-class');
    for (var i = 0; i < etichete.length; i++) etichete[i].parentNode.removeChild(etichete[i]);
  }

  // Pune bannerele generale cu tipul bannerelor personalizate în locul lor, cu poza personalizatului, și
  // scoate personalizatele înlocuite; întoarce pozițiile înlocuite (0 sau 1) și grilele din care au plecat.
  function inlocuiesteCuGenerale(anchors, ordered) {
    var inlocuite = [];
    var grile = [];
    var mutate = [];
    for (var i = 0; i < 2; i++) {
      var tip = tipulDinLink(ordered[i]);
      var general = tip === null ? null : generalulCuTipul(tip);
      if (general === null) continue;
      var dinainte = copiiiGrilei(general.parentNode).indexOf(general) + 1;
      if (grile.indexOf(general.parentNode) === -1) grile.push(general.parentNode);
      general.setAttribute('data-mxp-mutat', '1');
      general.setAttribute('data-mxp-pozitie', String(i + 1));
      pozaFaraIncarcareTarzie(general.querySelector(POZA_GENERAL));
      faraEtichetaAI(general);
      punePoza(general.querySelector(POZA_GENERAL), (ordered[i] && ordered[i].overrides) || {});
      anchors[i].parentNode.replaceChild(general, anchors[i]);
      inlocuite.push(i);
      mutate.push({ product_type: tipulScris(general), from: Math.min(50, dinainte), to: i + 1 });
    }
    if (mutate.length > 0) trimite('general_banner_reorder', { moved: mutate }, false);
    return { inlocuite: inlocuite, grile: grile };
  }

  // --- bannerele de rezervă, pe locurile goale ------------------------------

  var POZITIE_REZERVA = 3;

  // Tipurile deja pe pagină: ale bannerelor personalizate și toate tipurile scrise pe bannerele temei.
  function tipurilePePagina(ordered) {
    var out = [tipulDinLink(ordered[0]), tipulDinLink(ordered[1])];
    var toate = document.querySelectorAll(GENERAL_SELECTOR);
    for (var i = 0; i < toate.length; i++) {
      var tipuri = String(toate[i].getAttribute('data-mxp-product-type') || '').split(',');
      for (var k = 0; k < tipuri.length; k++) {
        if (tipuri[k].trim() !== '') out.push(normal(tipuri[k]));
      }
    }
    return out;
  }

  function element(tag, clasa, text) {
    var el = document.createElement(tag);
    el.className = clasa;
    if (isText(text)) el.textContent = text;
    return el;
  }

  // Un banner de rezervă, cu aceleași clase și aceeași structură ca bannerele temei, ca să ia stilul lor;
  // poza, ca la bannerele temei care nu sunt primele, se încarcă întârziat prin scriptul temei (`lazyload`).
  function bannerDeRezerva(slot) {
    var ov = slot.overrides || {};
    var banner = element(
      'div',
      'banner-general column-reducere banner-x2-reducere banner-reducere campanie-generala normal_size mxp-umplutura',
    );
    banner.setAttribute('data-mxp-rezerva', '1');
    banner.setAttribute('data-banner-id', slot.banner_id);
    var tip = tipulDinLink(slot);
    banner.setAttribute('data-mxp-product-type', tip !== null ? tip : '');

    var link = element('a', 'link');
    var href = safeUrl(ov.collection_link);
    if (href !== '') link.setAttribute('href', href);
    var label = ariaLabel(ov);
    if (label !== '') link.setAttribute('aria-label', label);

    var cadru = element('div', 'image-wrapper shadow video_no_image');
    var continut = element('div', 'content');
    if (isText(ov.headline)) continut.appendChild(element('h2', 'main-title', ov.headline));
    if (isText(ov.subhead)) continut.appendChild(element('p', 'subtitlu', ov.subhead));
    if (isText(ov.disclaimer)) continut.appendChild(element('p', 'mxp-umplutura__nota', ov.disclaimer));
    if (isText(ov.cta_text)) {
      var buton = element('button', 'banner-button', ov.cta_text);
      buton.setAttribute('type', 'button');
      buton.setAttribute('tabindex', '-1');
      continut.appendChild(buton);
    }
    var img = element('img', 'image image-d lazyload');
    img.setAttribute('width', String(IMG_RATIO_W));
    img.setAttribute('height', String(IMG_RATIO_H));
    img.setAttribute('decoding', 'async');
    punePoza(img, ov);

    cadru.appendChild(continut);
    cadru.appendChild(img);
    link.appendChild(cadru);
    banner.appendChild(link);
    return banner;
  }

  // `banner_click` pe un banner de rezervă, cu poziția rezervei.
  function ascultaClicRezerva(banner) {
    banner.addEventListener('click', function () {
      var date = { banner_id: banner.getAttribute('data-banner-id'), position: POZITIE_REZERVA };
      var a = banner.querySelector('a');
      var href = a ? a.getAttribute('href') : null;
      if (typeof href === 'string' && href.length <= 2048 && /^(https?:\/\/|\/)/.test(href)) date.link = href;
      trimite('banner_click', date, true);
    });
  }

  // Grilele rămase cu un număr impar de bannere primesc la final un banner de rezervă, primul cu un tip
  // care nu e încă pe pagină.
  function umpleGolurile(grile, rezerve, ordered) {
    if (!Array.isArray(rezerve) || rezerve.length === 0) return;
    var folosite = tipurilePePagina(ordered);
    for (var g = 0; g < grile.length; g++) {
      if (copiiiGrilei(grile[g]).length % 2 === 0) continue;
      for (var r = 0; r < rezerve.length; r++) {
        var tip = tipulDinLink(rezerve[r]);
        if (tip === null || folosite.indexOf(tip) !== -1 || !isText(rezerve[r].banner_id)) continue;
        var banner = bannerDeRezerva(rezerve[r]);
        grile[g].appendChild(banner);
        ascultaClicRezerva(banner);
        folosite.push(tip);
        break;
      }
    }
  }

  // --- bannerul camerei, cu rândul lui urcat sus -----------------------------

  // Perechea pusă lângă bannerul camerei, după principalul ei.
  var VECINUL_CAMEREI = { pat: 'canapea', canapea: 'pat', 'masă': 'canapea' };
  var CLASA_CAMEREI = 'mxp-camera';

  // Tipurile scrise pe un banner general, pregătite pentru comparație.
  function tipurileScrise(el) {
    var tipuri = String(el.getAttribute('data-mxp-product-type') || '').split(',');
    var out = [];
    for (var i = 0; i < tipuri.length; i++) {
      if (tipuri[i].trim() !== '') out.push(normal(tipuri[i]));
    }
    return out;
  }

  // Primul banner general al unei camere: cu exact două tipuri, dintre care unul e principalul cerut.
  function bannerulCamerei(principal) {
    var toate = document.querySelectorAll(GENERAL_SELECTOR);
    for (var i = 0; i < toate.length; i++) {
      var tipuri = tipurileScrise(toate[i]);
      if (tipuri.length === 2 && tipuri.indexOf(principal) !== -1) return toate[i];
    }
    return null;
  }

  // Bannerul camerei primește subtitlul, eticheta și linkul bannerului nostru 1; poza, titlul și insigna
  // rămân ale temei.
  function personalizeazaCamera(banner, ov) {
    banner.classList.add(CLASA_CAMEREI);
    var titluri = banner.querySelector('.titles-wrapper');
    if (titluri !== null && isText(ov.subhead)) titluri.appendChild(element('p', 'mxp-camera__subtitlu', ov.subhead));
    var cadru = banner.querySelector('.image_wrapper');
    if (cadru !== null) cadru.appendChild(element('span', 'mxp-banner__tag', 'Special pentru tine'));
    var a = banner.querySelector('a');
    var href = safeUrl(ov.collection_link);
    if (a !== null && href !== '') a.setAttribute('href', href);
  }

  // Urcă în locul secțiunii noastre rândul cu bannerul camerei primul și perechea lui alături; bannerul
  // scos din rând trece în locul bannerului camerei. Spune dacă a făcut-o: fără banner al camerei, fără
  // pereche, cu un rând care nu are exact 2 bannere sau cu un rând deja în ecran, nu atinge nimic.
  function urcaRandulCamerei(root, anchors, ordered) {
    var principal = tipulDinLink(ordered[0]);
    var vecin = principal !== null && VECINUL_CAMEREI.hasOwnProperty(principal) ? VECINUL_CAMEREI[principal] : null;
    var camera = principal === null ? null : bannerulCamerei(principal);
    var pereche = vecin === null ? null : bannerulCamerei(vecin);
    if (camera === null || pereche === null) return false;

    var rand = pereche.parentNode;
    var randulCamerei = camera.parentNode;
    var dinRand = copiiiGrilei(rand);
    var sectiuneaRandului = rand.closest('.shopify-section');
    var locul = root.closest('.shopify-section') || root;
    if (dinRand.length !== 2 || sectiuneaRandului === null || sectiuneaRandului === locul) return false;
    if (eDejaPeEcran(rand) || eDejaPeEcran(randulCamerei)) return false;

    var mutate = [
      { el: camera, from: copiiiGrilei(randulCamerei).indexOf(camera) + 1 },
      { el: pereche, from: dinRand.indexOf(pereche) + 1 },
    ];
    if (randulCamerei !== rand) {
      var scos = dinRand[0] === pereche ? dinRand[1] : dinRand[0];
      mutate.push({ el: scos, from: dinRand.indexOf(scos) + 1 });
      var dupaCamera = camera.nextSibling;
      rand.insertBefore(camera, scos);
      randulCamerei.insertBefore(scos, dupaCamera);
    }
    rand.insertBefore(camera, pereche);
    locul.parentNode.insertBefore(sectiuneaRandului, locul.nextSibling);

    personalizeazaCamera(camera, textele(anchors[0], ordered[0]));
    camera.setAttribute('data-mxp-pozitie', '1');
    pereche.setAttribute('data-mxp-pozitie', '2');
    var moved = [];
    for (var i = 0; i < mutate.length; i++) {
      var el = mutate[i].el;
      var tipul = String(el.getAttribute('data-mxp-product-type') || '').trim();
      el.setAttribute('data-mxp-mutat', '1');
      if (tipul === '') continue;
      moved.push({
        product_type: tipul.slice(0, 128),
        from: Math.min(50, Math.max(1, mutate[i].from)),
        to: Math.min(50, copiiiGrilei(el.parentNode).indexOf(el) + 1),
      });
    }
    if (moved.length > 0) trimite('general_banner_reorder', { moved: moved }, false);
    return true;
  }

  // Rulează după ce s-a citit toată pagina: bannerele generale stau mai jos decât secțiunea noastră.
  function cuPaginaCitita(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Anunță senzorul (mxp-tracker.js) că s-a hotărât dacă apar bannerele noastre: de aici încolo pozițiile
  // bannerelor de pe pagină sunt cele finale.
  function anuntaGata() {
    window.MXP_BANNERE_GATA = true;
    document.dispatchEvent(new Event('mxp:bannere-gata'));
  }

  // --- rularea --------------------------------------------------------------

  // Umple scheletul cu cele 2 sloturi și abia apoi arată secțiunea; pe paginile alese, întâi pune
  // bannerele generale în locul personalizatelor și rezervele pe locurile goale, după ce s-a citit toată
  // pagina; locul secțiunii se ocupă înainte, ca grilele temei să fie măsurate acolo unde vor sta. Când
  // urcă rândul camerei, scheletul nu se umple, ca pozele noastre să nu se încarce și să nu apară o clipă.
  function aplica(root, anchors, slots, rezerve) {
    var ordered = slots.slice().sort(function (a, b) {
      return (a.position || 0) - (b.position || 0);
    });
    var umple = function () {
      applyBanner(anchors[0], ordered[0]);
      applyBanner(anchors[1], ordered[1]);
    };

    var arata = function (inlocuite) {
      var images = root.querySelectorAll('.mxp-banner__image, ' + GENERAL_SELECTOR + ' ' + POZA_GENERAL);
      if (images.length > 0) revealImagesTogether(root, images);
      else root.classList.remove(PENDING_CLASS);

      root.classList.remove(AWAIT_CLASS);
      root.removeAttribute('hidden');

      raporteazaAfisarea(anchors, inlocuite);
      ascultaClicurile(root, anchors);
      anuntaGata();
    };

    if (window.MXP_CONFIG && window.MXP_CONFIG.reordonare === true) {
      rezervaLocul(root);
      cuPaginaCitita(function () {
        if (urcaRandulCamerei(root, anchors, ordered)) {
          elibereazaLocul(root);
          anuntaGata();
          return;
        }
        umple();
        var mutare = inlocuiesteCuGenerale(anchors, ordered);
        umpleGolurile(mutare.grile, rezerve, ordered);
        arata(mutare.inlocuite);
      });
    } else {
      umple();
      arata([]);
    }
  }

  // Ține minte dacă vizitatorul a primit bannere, ca data viitoare locul să fie rezervat dinainte.
  function tineMinte(aPrimit) {
    try {
      if (aPrimit) localStorage.setItem(MEMO_KEY, String(Date.now()));
      else localStorage.removeItem(MEMO_KEY);
    } catch (e) {
      // Memoria poate fi blocată (fereastră privată, setări). Fără ea pierdem doar rezervarea.
    }
  }

  // Rezervăm locul numai dacă semnul e proaspăt și acordul e încă dat: fără acord nu vin bannere,
  // deci un loc rezervat s-ar strânge degeaba.
  function stiuCaVinBannere() {
    if (cookie(CONSENT_COOKIE) !== 'on') {
      tineMinte(false);
      return false;
    }
    var salvat;
    try {
      salvat = localStorage.getItem(MEMO_KEY);
    } catch (e) {
      return false;
    }
    var cand = Number(salvat);
    return isFinite(cand) && cand > 0 && Date.now() - cand < MEMO_TTL_MS;
  }

  // Secțiunea se vede la proporția finală, fără textele scheletului.
  function rezervaLocul(root) {
    root.classList.add(PENDING_CLASS, AWAIT_CLASS);
    root.removeAttribute('hidden');
  }

  // Secțiunea se ascunde la loc și nu mai ocupă spațiu.
  function elibereazaLocul(root) {
    root.classList.remove(PENDING_CLASS, AWAIT_CLASS);
    root.setAttribute('hidden', '');
  }

  // Cererea deja pornită din <head> de mxp-preload.liquid, dacă e acolo; altfel o pornim acum.
  function raspunsul(anonId) {
    if (window.MXP_BANNERS_CERERE && typeof window.MXP_BANNERS_CERERE.then === 'function') {
      return window.MXP_BANNERS_CERERE;
    }
    var rezerve = window.MXP_CONFIG && window.MXP_CONFIG.reordonare === true ? '&rezerve=1' : '';
    var test = window.MXP_CONFIG && window.MXP_CONFIG.test === true ? '&test=1' : '';
    return fetch(API_BANNERS + '?anon_id=' + encodeURIComponent(anonId) + rezerve + test, {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res.status === 204 || !res.ok ? null : res.json();
    });
  }

  // Cere decizia; cheamă `gata(slots, rezerve)` cu exact 2 sloturi, altfel `gata(null)`. 204 înseamnă că
  // serverul n-are bannere pentru acest vizitator.
  function cereDeLaServer(anonId, gata) {
    raspunsul(anonId)
      .then(function (body) {
        var slots = body && body.slots;
        gata(Array.isArray(slots) && slots.length === 2 ? slots : null, (body && body.rezerve) || []);
      })
      .catch(function () {
        gata(null);
      });
  }

  // Secțiunea de umplut. Se caută întâi înăuntrul învelișului ei, fiindcă alte pagini pot arăta bannere
  // de exemplu cu aceleași clase; fără înveliș (secțiune randată altfel) rămâne căutarea după clasă.
  function gasesteSectiunea() {
    if (CFG.container) return document.querySelector(CFG.container);
    return document.querySelector(SECTIUNE_SELECTOR) || document.querySelector('.mxp-banners');
  }

  // Pornește cererea de bannere; spune dacă a pornit-o.
  function porneste() {
    var root = gasesteSectiunea();
    if (root === null) return false;

    // Fără adresă nu avem pe cine să întrebăm; o spunem, ca să nu pară un vizitator fără bannere.
    if (API_BANNERS === '') {
      if (window.console && console.warn) {
        console.warn('[mxp] missing MXP_CONFIG.endpoint — is mxp-preload rendered in theme.liquid?');
      }
      return false;
    }

    // Contul nu e pe lista din mxp-preload.liquid: nu cerem nimic, rămân bannerele fixe ale temei.
    if (window.MXP_CONFIG && window.MXP_CONFIG.personalizare === false) return false;

    // Exact 2 locuri în schelet, altfel nu atingem secțiunea.
    var anchors = root.querySelectorAll('.mxp-banner');
    if (anchors.length !== 2) return false;

    // Fără cookie vizitatorul e complet nou: serverul n-ar avea pe cine să caute.
    var anonId = cookie(ANON_COOKIE);
    if (!ANON_PATTERN.test(anonId)) return false;

    // Locul se rezervă doar pentru cine a primit bannere de curând; ceilalți nu văd nimic până
    // sosesc datele, deci nu există dreptunghi care să se arate și apoi să se strângă.
    var rezervat = stiuCaVinBannere();
    if (rezervat) rezervaLocul(root);

    cereDeLaServer(anonId, function (slotsNoi, rezerve) {
      if (slotsNoi === null) {
        if (rezervat) elibereazaLocul(root);
        tineMinte(false);
        anuntaGata();
        return;
      }
      aplica(root, anchors, slotsNoi, rezerve);
      tineMinte(true);
    });
    return true;
  }

  function run() {
    if (!porneste()) anuntaGata();
  }

  run();
})();
